import { Component, ElementRef, HostBinding, Input, OnChanges, Renderer2, SimpleChanges } from '@angular/core';

@Component({
    selector: 'core-button',
    templateUrl: './core-button.component.html',
    styleUrls: [ './core-button.component.scss' ],
})

export class CoreButtonComponent implements OnChanges
{
    //#region Class Constructor

    /**
     * Class constructor
     */
    constructor
        (
            public el: ElementRef,
            public renderer: Renderer2
        )
    {

    }

    //#endregion


    //#region Properties

    /**
     * Button color
     */
    @Input('color')
    public color: string = "#009ee3";

    /**
     * Text color
     */
    @Input('text-color')
    public textColor: string = "#fff";

    /**
     * Button styling profile
     * The string typings were added so that the AoT compiler can
     * asses and validate the string values supplied in the angular
     * templates
     */
    @Input('core-button-style')
    public buttonStyle: 'inline' | 'solid' | 'outline' | 'clear';

    /**
     * Button icon
     */
    @Input('icon')
    public icon: string;


    /**
     * Button disable flag
     */
    @Input('disabled')
    @HostBinding('class.disabled')
    public disabled: boolean;


    //#endregion


    //#region Methods

    /** 
     * initialization for button styling and class assignment
    */
    ngOnChanges(changes: SimpleChanges)
    {
        if (changes.buttonStyle || changes.color)
        {
            // prepare a list of all possible classes and 
            // clean the component out of the classes
            let classes: string[] = [CoreButtonStyle.Solid, CoreButtonStyle.Outline, CoreButtonStyle.Clear, CoreButtonStyle.Inline];

            // remove the classes from the component
            classes
                .forEach(c =>
                {
                    this.el.nativeElement.classList.remove(c);
                });

            // add the button style class
            this.el.nativeElement.classList.add(this.buttonStyle);

            switch (this.buttonStyle)
            {
                case CoreButtonStyle.Solid:
                    {
                        this.renderer.setStyle(this.el.nativeElement, 'color', this.textColor);
                        this.renderer.setStyle(this.el.nativeElement, 'background-color', this.color);
                        this.renderer.setStyle(this.el.nativeElement, 'border-color', this.color);
                        break;
                    }
                case CoreButtonStyle.Outline:
                    {
                        this.renderer.setStyle(this.el.nativeElement, 'color', this.color);
                        this.renderer.setStyle(this.el.nativeElement, 'background-color', 'transparent');
                        this.renderer.setStyle(this.el.nativeElement, 'border-color', this.color);
                        break;
                    }
                case CoreButtonStyle.Clear:
                case CoreButtonStyle.Inline:
                    {
                        this.renderer.setStyle(this.el.nativeElement, 'color', this.color);
                        this.renderer.setStyle(this.el.nativeElement, 'border-color', 'transparent');
                        this.renderer.setStyle(this.el.nativeElement, 'background-color', 'transparent');
                        break;
                    }
                default:

                    break;
            }
        }
    }


    //#endregion

}

/**
 * Enumeration of styling profiles
 */
export enum CoreButtonStyle
{
    Inline = "inline", // clear, no spacing
    Solid = "solid", // solid main coloring on background
    Outline = "outline", // outline and text set as main coloring
    Clear = "clear" // clear styling
}
